<div class="row" [formGroup]="orderMainDetailsFormGroup" >
  <div class="col-md-6">
    <div class="form-group">
      <label for="" class="form-label">رقم الطلب</label>
      <input type="text" class="form-control" readonly formControlName="reference_number"/>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label for="" class="form-label"> الفاحص </label>
      <ng-select bindLabel="name" (scrollToEnd)="onScrollPagination('inspectors', getInspectors.bind(this))"
        #selectInsp
        placeholder="يرجى تحديد الفاحص"
        appendTo="body"
        formControlName="order_inspector"
        [searchable]="true"
        (removed)="resetSearch('inspectors', getInspectors.bind(this))"
        (search)="searchtext('inspectors', getInspectors.bind(this), this.selectInsp.searchTerm)"
        (clear)="resetSearch('inspectors', getInspectors.bind(this))"
        (change)="inspectorData($event)"
        (open)="resetSearch('inspectors', getInspectors.bind(this))"
        [virtualScroll]="true"
        [clearable]="true">
        @for (inspector of inspectors; track inspector) {
          <ng-option [value]="inspector.id" >
            {{inspector.full_name}}
          </ng-option>
        }
      </ng-select>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label for="" class="form-label"> الفاحصين الإضافيين </label>
      <ng-select bindLabel="name" (scrollToEnd)="onScrollPagination('inspectors', getInspectors.bind(this))"
        #selectExperts
        placeholder="يرجى تحديد الفاحصين الإضافيين"
        appendTo="body"
        [searchable]="true"
        (removed)="resetSearch('inspectors', getInspectors.bind(this))"
        (search)="searchtext('inspectors', getInspectors.bind(this), this.selectExperts.searchTerm)"
        (clear)="resetSearch('inspectors', getInspectors.bind(this))"
        (change)="setOrderExperts($event)"
        (open)="resetSearch('inspectors', getInspectors.bind(this))"
        [virtualScroll]="true"
        [clearable]="true"
        [items]="availableExperts"
        bindValue="id"
        bindLabel="full_name">
      </ng-select>
    </div>
    @if(ordersExperts?.length > 0) {
      <div class="selected-experts-wrapper">
        @for(expert of ordersExperts; track expert.id; let index = $index) {
          <div class="selected-experts">
            <span>{{expert.expert_name}}</span>
            <img src="assets/images/svg/close-icon.svg" alt="" (click)="removeOrderExpert(expert, index)">
          </div>
        }
      </div>
    }
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label for="" class="form-label">المدقق</label>
      <ng-select bindLabel="name" (scrollToEnd)="onScrollPagination('qualityControls',getAvaliableQc.bind(this))"
        #selectQc
        placeholder="يرجى تحديد المدقق"
        appendTo="body"
        formControlName="qc_auditor"
        [searchable]="true"
        (removed)="resetSearch('qualityControls', getAvaliableQc.bind(this))"
        (search)="searchtext('qualityControls', getAvaliableQc.bind(this), this.selectQc.searchTerm)"
        (clear)="resetSearch('qualityControls', getAvaliableQc.bind(this))"
        (open)="resetSearch('qualityControls', getAvaliableQc.bind(this))"
        [virtualScroll]="true"
        [clearable]="true">
        @for (qc of qualityControls; track qc.id) {
          <ng-option [value]="qc.id" >
            {{qc.full_name}}
          </ng-option>
        }
      </ng-select>
    </div>
  </div>
  @if (orderType == 5) {
    <div class="col-md-6">
      <div class="form-group">
        <label for="" class="form-label"> تخصص مزود الخدمة</label>
        <ng-select bindLabel="name" class="single-select"
          #selectStatus
          placeholder="يرجى تحديد تخصص مزود الخدمة"
          appendTo="body"
          formControlName="inspector_academic_major"
          [searchable]="true"
          [clearable]="true">
          @for (item of acadamicMajor; track item) {
            <ng-option [value]="item.id" >
              {{item.name}}
            </ng-option>
          }
        </ng-select>
      </div>
    </div>
  }
  <div class="col-md-6">
    <div class="form-group">
      <label for="" class="form-label"> حالة الفحص </label>
      <ng-select bindLabel="name" class="single-select"
        #selectStatus
        placeholder="  يرجى تحديد  حالة الفحص  "
        appendTo="body"
        formControlName="status"
        [searchable]="true"
        [clearable]="true">
        @for (item of status; track item) {
          <ng-option [value]="item.id" >
            {{item.name}}
          </ng-option>
        }
      </ng-select>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label for="" class="form-label">هدف العميل من الطلب</label>
      <ng-select bindLabel="name" class="single-select"
        #selectStatus
        placeholder="هدف العميل من الطلب"
        appendTo="body"
        formControlName="client_goal"
        [searchable]="true"
        [clearable]="true">
        @for (item of clientGoals; track item) {
          <ng-option [value]="item.id" >
            {{item.name}}
          </ng-option>
        }
      </ng-select>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label for="" class="form-label">اسم المطور العقاري</label>
      <input type="text" class="form-control" readonly formControlName="real_estate_developer"/>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label for="" class="form-label">اسم المشروع</label>
      <input type="text" class="form-control" readonly formControlName="real_estate_project"/>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label for="" class="form-label">نوع علاقتك بالعقار</label>
      <input type="text" class="form-control" readonly [value]="clientPropertyRelationName"/>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label for="" class="form-label">{{dateLabel}} </label>
      <mat-form-field (click)="picker.open()" appearance="outline" >
        <input matInput formControlName="order_date" [matDatepicker]="picker" disabled />
        <mat-datepicker-toggle
          matSuffix
          [for]="picker"
          ><mat-icon matDatepickerToggleIcon class="calender-icon">
          <img src="assets/images/svg/calendar-admin-icon.svg" alt="" >
        </mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #picker [disabled]="disableDate" ></mat-datepicker>
    </mat-form-field>
    <div class="checkBox-wrapper">
      <label class="checkbox-container" >
        <input type="checkbox" formControlName="is_inspection_later" (click)="toggleDisableDate($event)">
        <span class="checkmark"> </span>
      </label>
      <span class="checkbox-label"> موعد مفتوح
        <small>(تحديد الموعد لاحقا)</small> </span>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="form-group">
      <label for="" class="form-label">{{periodLabel}} </label>
      <app-select
        [optionItems]="inspectionPeriods"
        [placeholder]="'يرجى تحديد الفتره'"
        [initValues] = "selectedPeriods"
        [id]="'order_periods'"
        [disableSelect] = "disableSelect"
        (selectedOptions)="setOrderPeriods($event , true)">
      </app-select>
    </div>
  </div>
  @if(orderData.contract) {
  <div class="col-md-6">
    <select-paginated
          [placeholder]="'ربط مع طلب سابق'"
          [label]="'ربط مع طلب سابق'"
          [bindLabel]="'reference_number'"
          [items]="referenceNumberList"
          [selectedContract]="selectedRefrenceNumber"
          (itemData)="setRefrenceData($event)"
          (params)="getRefrenceNumberByParams($event)"
          [pageCount]="refrencePageCount"
      >
    </select-paginated>
  </div>
  }
  <div class="col-md-12">
    <div class="notes-section">
      <label for="" class="form-label">ملاحظات العميل</label>
      <textarea
        class="form-control"
        formControlName="notes"
        name="notes"
        maxlength="500"
      ></textarea>
    </div>
  </div>

  <div class="col-md-12 mt-3">
    <div class="notes-section">
      <label for="" class="form-label">ملاحظات داخلية</label>
      <textarea
        class="form-control"
        formControlName="internal_notes"
        name="internal_notes"
        maxlength="5000"
      ></textarea>
    </div>
  </div>

  <div  class="save-section col-md-12">
    <div class="save-btn-wrapper">
      <app-action-button (submitAction)="save($event)"></app-action-button>
    </div>
  </div>
  <div class="col-md-12">
    @if (alertmsg) {
      <div class="alert-box">
        <img alt=""
          src="assets/images/svg/error-icon.svg"
          class="close-alert"
          (click)="hideErrorMSG()"
          alt=""
          />
          <p class="alert-msg">{{errorMessage}}</p>
        </div>
      }
  </div>
